import { Alert, Box } from "@mui/material";

import { carrierHasLostShipment } from "utils";

import { ShipmentQuoteList } from "../ShipmentQuoteList";

interface Props {
  shipment: CarrierCondensedShipment | undefined;
}

export function CarrierQuoteTab(props: Props) {
  const { shipment } = props;

  if (shipment === undefined) {
    return null;
  }

  return (
    <>
      {carrierHasLostShipment(shipment) && (
        <Box mb="1rem">
          <Alert severity="warning">This shipment is no longer bookable.</Alert>
        </Box>
      )}
      <ShipmentQuoteList shipment={shipment} />
    </>
  );
}
